export function intercomEvent(eventName, data) {
  if (!eventName) { throw new Error('intercom event needs an event name'); }
  window.Intercom?.('trackEvent', eventName, data);
}
